// hooks
import { useState } from 'react';
import { useFetch } from './useFetch';

// default values
import { defaultCurrencies } from '../utils/defaults';

export function useCurrencies() {
	// session
	const accessToken = sessionStorage.getItem('accessToken');
	const idToken = sessionStorage.getItem('idToken');

	// state
	const [currencies, setCurrencies] = useState<string[]>(defaultCurrencies);

	const { isLoading: isLoadingCurrencies, refetch: refetchCurrencies } = useFetch({
		isEnabled: true,
		url: `${process.env.REACT_APP_API_URL}/currencies`,
		options: {
			headers: {
				Authorization: `Bearer ${accessToken}`,
				User: String(idToken),
			},
		},
		onSuccess: (res) => {
			if (res.data.length) {
				setCurrencies(res.data);
			}
		},
	});

	return {
		currencies,
		isLoadingCurrencies,
		refetchCurrencies,
		setCurrencies,
	};
}
